import { useEffect } from "react"

import eventDetails from "../../../../utility/event-details"

import './index.css'
import scrollToTop from "../../../../utility/scrollToTop";

import Carousel from "../../../utils/Carousel";

const EventsTemplate = ({ event_idx }) => {
  useEffect(() => {
    scrollToTop();
  }, []);

  const event = eventDetails[event_idx]

  return (
    <div className='evt-template--wrapper'>

      <Carousel images={event.images} />

      <div className='evt-template--details'>
        <div className="evt-template--timings">
          <h2>{event.name}</h2>
          <p className='event-date'>📅 Date: <span className='underline'>{event.date.toLocaleDateString('en-GB')}</span></p>
          <p className='event-time'>⏰ Time: <span className='underline'>{event.time}</span></p>
        </div>
        <div className='evt-template--description'>
          <div className="evt-template--about">
            <input type="checkbox" name="readmore" id="readmore" />
            <h2 className="cool-looking-underline">
              About
            </h2>
            <div className="evt-template--about-content">
              <p className="evt-template--about-desc">
                {event.description}
              </p>
              <div className="evt-template--btn">
                <label htmlFor="readmore"
                  data-more="Read More >>"
                  data-less="Read Less <<"
                ></label>
              </div>
            </div>
          </div>
          {
            event.keyPoints
              ?
              <div className="evt-template--keypoints">
                <h2 className="cool-looking-underline">
                  Keypoints
                </h2>
                <ul>
                  {
                    event.keyPoints.map((kp, idx) => <li key={idx}>{kp}</li>)
                  }
                </ul>
              </div>
              :
              <></>
          }
        </div>

      </div>
    </div>
  )
}

export default EventsTemplate